/* @flow */
import React from 'react';
import {withStyles} from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import Paper from '@material-ui/core/Paper';
import Divider from '@material-ui/core/Divider';
import Select from '@material-ui/core/Select';
import MenuItem from '@material-ui/core/MenuItem';
import DateUtils from '../../../services/Utility/DateUtils';
import InvoiceService from '../../../services/InvoiceService';

const styles = theme => ({
  root: {
    margin: 'auto',
    padding: '2px 4px',
    display: 'flex',
    alignItems: 'center',
    width: '100%',
    backgroundColor: theme.palette.background.paper,
  },
  button: {
    margin: theme.spacing(0.5, 0),
  },
  input: {
    marginLeft: 8,
    flex: 1,
  },
  divider: {
    width: 1,
    height: 28,
    margin: 4,
  }
});

const startYear = 2019;

type Props = {|
  classes: ClassNameMap,
  onYearChange?: (value: number) => void;
|};
type State = {|
  year: number
|}

class InvoiceDownload extends React.Component<Props, State> {
  state: State = {
    year: DateUtils.currentYear
  };

  getYearOptions = () => {
    return Array((DateUtils.currentYear + 1) - startYear)
    .fill()
    .map((_, i) =>
        <MenuItem key={i} value={startYear + i}>{startYear + i}</MenuItem>
    );
  };

  downloadExcel = () => {
    InvoiceService.exportInvoicesToExcel(this.state.year);
  }

  render() {
    const {classes, onYearChange} = this.props;
    const {year} = this.state;

    return (
        <Paper className={classes.root}>
            <Select
                className={classes.input}
                value={year}
                onChange={(e) => {
                    const year = e.target.value
                    this.setState({ year: year });

                    if (onYearChange) {
                         onYearChange(year);
                    }
                }}
            >
                {this.getYearOptions()}
            </Select>
            <Divider className={classes.divider} />
            <Button className={classes.confirmButton} variant='contained' size='large' color='primary' onClick={this.downloadExcel}>
                Download
            </Button>
        </Paper>
    );
  }
}

export default (withStyles(styles)(InvoiceDownload));
